import { render, staticRenderFns } from "./ClientUserManagement.vue?vue&type=template&id=7b16484a"
import script from "./ClientUserManagement.vue?vue&type=script&lang=js"
export * from "./ClientUserManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports